import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

import ModalFooter from "../../../intelws_portal/constructs/modal/ModalFooter";
import ModalHeader from "../../../intelws_portal/constructs/modal/ModalHeader";
import ModalDatePicker from "../../../intelws_portal/constructs/modal/ModalDatePicker";
import ModalInputText from "../../../intelws_portal/constructs/modal/ModalInputText";
import ModalCommetText from "../../../intelws_portal/constructs/modal/ModalCommentText";
import { get, getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";
import { parseQueryResponseOnFail, parseQueryResponseOnSuccess } from "../../../declarations/common_utils";
import { AxiosResponse } from "axios";
import { Link, useHistory } from "react-router-dom";

import * as urls from "../../Urls";
import { request } from "http";
import Button from "../../../intelws_portal/constructs/elements/Button";
import { IFollowUpEvents } from "../common/LeadTracking";

interface IFollowUpInfo {
    id: number,
    uf_user_id: number,
    uf_user_name: string,
    uf_subject: string,
    uf_description: string,
    uf_date: string
}

interface IFetchFollowUpInfo extends AxiosResponse {
    data: {
        data: IFollowUpInfo
    }
}

interface IEditFollowUpInfo extends AxiosResponse {
    data: {
        data: IFollowUpEvents
    }
}

export interface IModalLeadFollowUpInfoProps {
    leadFollowUpId: number,
    isClient?: boolean,
    markAsCompleted?: (leadFollowUpId: number, success: string[], fail: string[]) => void,
    editFollowUp?: (newEvent: IFollowUpEvents | undefined, success: string[], fail: string[]) => void,
    closeModal?: () => void,
}

function ModalLeadFollowUpInfo(props: IModalLeadFollowUpInfoProps) {
    const ENDPOINT = "/api/leads/";
    const USER_ENDPOINT = "/api/userlist/";

    const [dueDate, setDueDate] = React.useState("");
    const [leadId, setLeadId] = React.useState(-1);
    const [leadName, setLeadName] = React.useState("");
    const [subject, setSubject] = React.useState("");
    const [description, setDescription] = React.useState("");

    const [disable, setDisable] = React.useState(true);

    const history = useHistory();

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        $("#leadFollowUpInfoModal").on("hidden.bs.modal", clearForm);

        return () => {
            $("#leadFollowUpInfoModal").off("hidden.bs.modal");
        }
    }, [])

    React.useEffect(() => {
        if (props.leadFollowUpId != -1) {
            const queryParams = {
                section: "get_lead_follow_up_info",
                user_follow_up_id: props.leadFollowUpId.toString()
            }
            const requestResponse = get(ENDPOINT, cancelTokenSource.current.token, queryParams) as Promise<IFetchFollowUpInfo>;

            requestResponse.then((response) => {
                setLeadId(response.data.data.uf_user_id);
                setLeadName(response.data.data.uf_user_name);
                setSubject(response.data.data.uf_subject);
                setDescription(response.data.data.uf_description);
                setDueDate(response.data.data.uf_date);
            })
        }

    }, [props.leadFollowUpId])

    function clearForm() {
        setDueDate("");
        setSubject("");
        setDescription("");
        setLeadId(-1);
        setLeadName("");
        setDisable(true);
        props?.closeModal?.();
    }

    function submitLeadFollowUpTransition(status: "completed" | "unresolved") {
        const leadFollowUpId = props.leadFollowUpId;

        const formData = new FormData();
        formData.append("lead_follow_up_id", leadFollowUpId.toString());
        formData.append("status", status);

        const queryParams = {
            section: "lead_follow_up_transition"
        }

        const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams);

        requestResponse.then((response) => {
            let [success, fail] = parseQueryResponseOnSuccess(response);
            props?.markAsCompleted?.(props.leadFollowUpId, success, fail);
        }).catch((error) => {
            let [success, fail] = parseQueryResponseOnFail(error);
            props?.markAsCompleted?.(props.leadFollowUpId, success, fail);
        }).finally(() => {
            $("#leadFollowUpInfoModal").modal("hide");
        })
    }

    function onFormChange(field: "subject" | "description" | "follow_up", value: string) {
        setDisable(false);
        if (field == "subject") {
            setSubject(value);
        } else if (field == "description") {
            setDescription(value);
        } else if (field == "follow_up") {
            setDueDate(value);
        }
    }

    function onFollowUpSave() {
        const leadFollowUpId = props.leadFollowUpId;
        
        const queryParams = {
            section: "edit_follow_up"
        }

        const formData = new FormData();
        formData.append("follow_up_id", leadFollowUpId.toString());
        formData.append("subject", subject);
        formData.append("description", description);
        formData.append("follow_up_date", dueDate);

        const requestResponse = post(USER_ENDPOINT, formData, cancelTokenSource.current.token, queryParams) as Promise<IEditFollowUpInfo>

        requestResponse.then((response) => {
            let [success, fail] = parseQueryResponseOnSuccess(response);
            props.editFollowUp?.(response.data.data, success, fail);
        }).catch((error) => {
            let [success, fail] = parseQueryResponseOnFail(error);
            props.editFollowUp?.(undefined, success, fail);
        }).finally(() => {
            $("#leadFollowUpInfoModal").modal("hide");
        })
    }
    
    function getModalContent() {
        const dashboardType = props.isClient ? "Client" : "Lead";
        const buttonConfig = [
            {
                buttonName: `Go To ${dashboardType} Dashboard`,
                inactive: false,
                callback: (e:  React.MouseEvent<HTMLButtonElement>) => {
                    $("#leadFollowUpInfoModal").modal("hide");
                    history.push(`${urls.BASE_COMMON_CLIENT_DASHBOARD}${leadId}`)
                }
            },
            {
                buttonName: "Mark as Unresolved",
                inactive: false,
                callback: (e:  React.MouseEvent<HTMLButtonElement>) => submitLeadFollowUpTransition("unresolved")
            }
        ]

        return (
            <React.Fragment>
                <ModalHeader title={`Follow Up - ${leadName}`} />
                <div className="modal-body">
                    <ModalInputText title="Subject" value={subject} onChange={(e) => onFormChange("subject", e.target.value)} required  />
                    <br />
                    <ModalCommetText title="Description" placeholder="Enter Follow Up Description Here" value={description} onChange={(e) => onFormChange("description", e.target.value)} required />
                    <br />
                    <ModalDatePicker title="Follow Up Date" value={dueDate} onChange={(e) => onFormChange("follow_up", e.target.value)} required />
                    <br />
                    <Button buttonValue={"Save"} active={!disable} onClick={onFollowUpSave} />
                </div>
                <ModalFooter saveCallback={() => submitLeadFollowUpTransition("completed")} saveInactive={false} disable={false} buttonConfig={buttonConfig} saveBtnName="Mark as Completed"/>
            </React.Fragment>
        )
    }

    function relativeRender() {
        return <div className="modal fade custom-modal text-center" id="leadFollowUpInfoModal" tabIndex={-1}>
                <div className="modal-dialog text-left modal-lg">
                    <div className="modal-content">
                        {getModalContent()}
                    </div>
                </div>
            </div>
    }
    
    return ReactDOM.createPortal(relativeRender(), document.getElementById("modal") as Element);
}

export default ModalLeadFollowUpInfo;